import Alert from "bootstrap/js/dist/alert";

document.addEventListener("turbo:load", function () {
  let alertList = document.querySelectorAll('.alert');
  alertList.forEach(function (alert) {
    new Alert(alert);
  });
});
